module.exports = __webpack_public_path__ + "dc508b5c64d14dcbdf8c91ee1deef238.png";